import { Controller } from "@hotwired/stimulus"
import { SIDE_FILTER_SELECTOR } from "@/lib/Listing/MobileFilterHelpers.js"
import { applyFilterState, FILTERS_HYDRATED_EVENT } from "@/lib/Listing/FilterState.js"

const NAV_SEARCH_SELECTOR = "#guided-search-desktop, #mobile-search-modal"

export default class extends Controller {
  static values = { state: Object }

  connect() {
    document
      .querySelectorAll(`${SIDE_FILTER_SELECTOR}, ${NAV_SEARCH_SELECTOR}`)
      .forEach((scope) => applyFilterState(scope, this.stateValue))
    document.dispatchEvent(new CustomEvent(FILTERS_HYDRATED_EVENT))
  }
}
